export enum ApplicationEvent {
  OnAuthorized = 'onAuthorized',
  OnUnauthorized = 'onUnauthorized',
  OnMaintenance = 'OnMaintenance',
  OnUserOrgChanged = 'OnUserOrgChanged',
  OnAppReady = 'OnAppReady',
  OnAppReset = 'OnAppReset'
}
